import AssessmentIcon from "@mui/icons-material/Assessment";
import SettingsIcon from "@mui/icons-material/Settings";
import { Menu, usePermissions } from "react-admin";

export function CustomMenu() {
  const { permissions } = usePermissions();
  const isAdmin = permissions === "admin";
  const isStaff = permissions === "admin" || permissions === "broker";  // отчёты — и брокеру
  return (
    // На мобиле пунктов больше, чем высота экрана: делаем само меню скролл-контейнером с
    // ограниченной высотой (иначе последние пункты — «Отчёты»/«Настройки» — не долистать,
    // список пружинил обратно). pb — чтобы низ не прятался под браузерный chrome.
    <Menu sx={{ maxHeight: "100dvh", overflowY: "auto", pb: 6 }}>
      {isAdmin && <Menu.DashboardItem />}
      <Menu.ResourceItems />
      {isStaff && <Menu.Item to="/reports" primaryText="Отчёты" leftIcon={<AssessmentIcon />} />}
      {isAdmin && <Menu.Item to="/settings" primaryText="Настройки" leftIcon={<SettingsIcon />} />}
    </Menu>
  );
}
